export const questions =[
   {
      "id":18,
      "question":"Capital of Cyprus",
      "answer":"Nicosia",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Nicosia.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Nicosia.jpg"
      },
      "favourite":false,
      "tips":[
         "Esto es un tip",
         "Esto es otro"
      ]
   },
   {
      "id":12,
      "question":"Capital of Honduras",
      "answer":"Tegucigalpa",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Tegucigalpa.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Tegucigalpa.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   },
   {
      "id":36,
      "question":"Capital of Italy",
      "answer":"Rome",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Rome.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Rome.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   },
   {
      "id":14,
      "question":"Capital of Belgium",
      "answer":"Brussels",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Brussels.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Brussels.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   },
   {
      "id":30,
      "question":"Capital of Ireland",
      "answer":"Dublin",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Dublin.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Dublin.jpg"
      },
      "favourite":false,
      "tips":[
         

      ]
   },
   {
      "id":22,
      "question":"Capital of Latvia",
      "answer":"Riga",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Riga.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Riga.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   },
   {
      "id":11,
      "question":"Capital of Canada",
      "answer":"Ottawa",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Ottawa.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Ottawa.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   },
   {
      "id":13,
      "question":"Capital of Madagascar",
      "answer":"Antananarivo",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Antananarivo.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Antananarivo.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   },
   {
      "id":16,
      "question":"Capital of Ecuador",
      "answer":"Quito",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Quito.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Quito.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   },
   {
      "id":27,
      "question":"Capital of Denmark",
      "answer":"Copenhagen",
      "author":{
         "id":1,
         "isAdmin":true,
         "username":"admin",
         "photo":{
            "filename":"lechuck.jpg",
            "mime":"image/jpeg",
            "url":"https://quiz.dit.upm.es/uploads/120e194dd3a5a1fc88b1d1f2e977b7372f5aa18fab64765ce4b9d4b17b987da7"
         }
      },
      "attachment":{
         "filename":"capitals/Copenhagen.jpg",
         "mime":"image/jpeg",
         "url":"https://quiz.dit.upm.es/uploads/capitals/Copenhagen.jpg"
      },
      "favourite":false,
      "tips":[

      ]
   }
]